import React from "react";
import { Link } from "react-router-dom";
import "./footer.css"; // Optional: move the CSS styles into a separate file
import { createSlug } from "../Helper/index.js";

const Footer = () => {
  // const navigate = useNavigate();
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  // const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  // const closeDropdown = () => setDropdownOpen(false);
  const handleLinkClick = () => {
    // setDropdownOpen(false);
    window.scrollTo({
      top: 0, // Scroll to the top
      behavior: "smooth", // Smooth scrolling
    });
  };

  // const [hoveredSection, setHoveredSection] = useState(null);

  // const combineHarvesterProducts = [
  //     { id: '1', productName: 'Dasmesh 9100', subCate: 'Combineharvester' },
  //     { id: '2', productName: 'Dasmesh 9100 Maize', subCate: 'Combineharvester' },
  //     { id: '3', productName: 'Dasmesh 7100', subCate: 'Combineharvester' },
  //     { id: '4', productName: 'Dasmesh 3100', subCate: 'Combineharvester' },
  //     { id: '5', productName: 'Dasmesh 912 2WD', subCate: 'Combineharvester' },
  //     { id: '6', productName: 'Dasmesh 912 4WD', subCate: 'Combineharvester' },
  //     { id: '7', productName: 'Dasmesh 731 Track', subCate: 'Combineharvester' },
  //     { id: '8', productName: 'Dasmesh 726 Track', subCate: 'Combineharvester' },
  //     { id: '9', productName: 'Dasmesh Maize Header', subCate: 'Combineharvester' },
  //     { id: '10', productName: 'Dasmesh Rotavator', subCate: 'Rotavator' },
  //     { id: '11', productName: 'Dasmesh Laser Land Leveller', subCate: 'Laser Land Leveller' },
  //     { id: '12', productName: 'Dasmesh Super Seeder', subCate: 'superseeder' },
  //     { id: '13', productName: 'Dasmesh Straw Reaper', subCate: 'strawreaper' },
  //     { id: '14', productName: 'Dasmesh Square Baler', subCate: 'squarebaler' },
  //     { id: '15', productName: 'Dasmesh Round Baler', subCate: 'dsrdrill' },
  //     { id: '16', productName: 'Dasmesh Hey Rake', subCate: 'superseeder' },
  //     { id: '17', productName: 'Dasmesh Zero Till Drill', subCate: 'squarebaler' },
  //     { id: '18', productName: 'Dasmesh DSR Drill', subCate: 'squarebaler' },
  //     { id: '19', productName: 'Dasmesh Paddy Straw Chopper', subCate: 'squarebaler' },

  // ];

  const combineHarvesterProducts = [
    { id: "1", productName: "Dasmesh 9100", subCate: "Combineharvester" },
    { id: "2", productName: "Dasmesh 9100 Maize", subCate: "Combineharvester" },
    { id: "3", productName: "Dasmesh 7100", subCate: "Combineharvester" },
    { id: "4", productName: "Dasmesh 3100", subCate: "Combineharvester" },
    { id: "5", productName: "Dasmesh 912 2WD", subCate: "Combineharvester" },
    { id: "6", productName: "Dasmesh 912 4WD", subCate: "Combineharvester" },
    { id: "7", productName: "Dasmesh 731 Track", subCate: "Combineharvester" },
    { id: "8", productName: "Dasmesh 726 Track", subCate: "Combineharvester" },
    {
      id: "9",
      productName: "Dasmesh Maize Header",
      subCate: "Combineharvester",
    }, {
      id: "20",
      productName: "Dasmesh 831",
      subCate: "Combineharvester",
    },
  ];

  const agriImplementsProducts = [
    { id: "10", productName: "Dasmesh Rotavator", subCate: "agriImplements" },
    {
      id: "11",
      productName: "Dasmesh Laser Land Leveller",
      subCate: "agriImplements",
    },
    {
      id: "12",
      productName: "Dasmesh Super Seeder",
      subCate: "agriImplements",
    },
    {
      id: "13",
      productName: "Dasmesh Straw Reaper",
      subCate: "agriImplements",
    },
    {
      id: "14",
      productName: "Dasmesh Square Baler",
      subCate: "agriImplements",
    },
    { id: "15", productName: "Dasmesh Round Baler", subCate: "agriImplements" },
    { id: "16", productName: "Dasmesh Hey Rake", subCate: "agriImplements" },
    {
      id: "17",
      productName: "Dasmesh Zero Till Drill",
      subCate: "agriImplements",
    },
    { id: "18", productName: "Dasmesh DSR Drill", subCate: "agriImplements" },
    {
      id: "19",
      productName: "Dasmesh Paddy Straw Chopper",
      subCate: "agriImplements",
    },
  ];

  // const handleExploreClick = (product) => {
  //   navigate(`/Product-Detail/${product.id}`, { state: { product } });
  //   window.scrollTo(0, 0);
  // };
  return (
    <footer className="footer">
      <div className="row">
        <div className="col-lg-3 col-12">
          <div className="footer-first-section" id="mobileview-footer">
            <div className="footer-hdeading">
              <div className="footer-first-section-border"></div>
              <h4>About us</h4>
            </div>
            <div className="footer-links-special">
              <p>
                DASMESH Group is a trusted name in agricultural machinery with
                over 43 years of experience in providing innovative and
                sustainable solutions for farmers worldwide. We are committed to
                delivering high-quality products designed to enhance farming
                efficiency and productivity.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="footer-first-special-section">
            <div className="footer-hdeading">
              <div className="footer-first-section-border"></div>
              <h4>Important Links</h4>
            </div>
            <div className="footer-links">
              {/* <div className="dropdown-container" onMouseLeave={closeDropdown}>
                                <span
                                    className="dropdown-trigger"
                                    onMouseEnter={toggleDropdown}
                                    onClick={toggleDropdown}
                                >
                                    About Us
                                </span>
                                {dropdownOpen && (
                                    <div className="dropdown-menu">
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                        <Link onClick={handleLinkClick} to="/">
                                            
                                        </Link>
                                    </div>
                                )}
                            </div> */}
              <Link to="/Aboutdsamesh" onClick={handleLinkClick}>
                <span>About Dasmesh</span>
              </Link>
              <br />
              <Link to="/Aboutvalue" onClick={handleLinkClick}>
                <span>Our Values</span>
              </Link>
              <br />
              <Link to="/Aboutfacility" onClick={handleLinkClick}>
                <span>Facilities</span>
              </Link>
              <br />
              <Link to="/Aboutaward" onClick={handleLinkClick}>
                <span>Award & Recognition</span>
              </Link>
              <br />
              <Link to="/Aboutcmdmessage" onClick={handleLinkClick}>
                <span>CMD’s Message</span>
              </Link>
              <br />
              <Link to="/Aboutpolicy" onClick={handleLinkClick}>
                <span>Quality Policy</span>
              </Link>
              <br />
              <Link to="/contact" onClick={handleLinkClick}>
                <span>Reach Us</span>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="footer-first-section">
            <div className="footer-hdeading">
              <span className="footer-first-section-border"></span>
              <h4>Our Products</h4>
            </div>
            <div className="footer-links" id="footer-link">
              <div className="footer-links">
                <Link
                  to={`/${createSlug(combineHarvesterProducts[0].productName)}`}
                  style={{ cursor: "pointer" }} onClick={() => window.scrollTo(0, 0)}
                >
                  <span>COMBINE HARVESTER</span>
                </Link>
                <br />
                <Link
                  to={`/${createSlug(agriImplementsProducts[0].productName)}`}
                  style={{ cursor: "pointer" }} onClick={() => window.scrollTo(0, 0)}
                >
                  <span>AGRI. IMPLEMENTS</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="footer-first-section" id="desktoview">
            <div className="footer-hdeading">
              <span className="footer-first-section-border"></span>
              <h4>Reach us</h4>
            </div>
            <div className="footer-address">
              <p>Dasmesh Mechanical Works Pvt .LTD </p>
              <p>Dasmesh Agricultural Industries Pvt. Ltd</p>
              <p>Raikot Road, Malerkotla,Pincode - 148023, Punjab, INDIA.</p>
              <p>Domestic Sales: <a href="tel:+918872688726">+91 88726 88726</a></p>
              <p>Overseas Sales: <a href="tel:+919417025726">+91 94170 25726</a></p>
              <p><a href="mailto:vp.sales@dasmesh.com">vp.sales@dasmesh.com</a></p>
              <div className="social-media">
                <a
                  target="blank"
                  href="https://www.instagram.com/dasmeshgroup/"
                >
                  <img
                    src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196631/instagram_przczs.png"
                    alt="social"
                  />
                </a>
                <a target="blank" href="https://www.facebook.com/dasmeshgroup">
                  <img
                    src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196631/facebook_ihbvi6.png"
                    alt="social"
                  />
                </a>
                <a target="blank" href="https://www.youtube.com/dasmeshgroup">
                  <img
                    src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196691/youtube_ylqcgl.png"
                    alt="social"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-first-section" id="mobileview">
        <div className="footer-hdeading">
          <span className="footer-first-section-border"></span>
          <h4>CONTACT</h4>
        </div>
        <div className="footer-address">
          <p>Raikot Road, Malerkotla,Pincode - 148023, Punjab, INDIA.</p>
          <p>Domestic Sales: <a href="tel:+918872688726">+91 88726 88726</a></p>
          <p>Overseas Sales: <a href="tel:+919417025726">+91 94170 25726</a></p>
          <p><a href="mailto:sales@dasmesh.com">sales@dasmesh.com</a></p>
          <div className="social-media">
            <a
              target="blank"
              href="https://www.instagram.com/dasmeshgroup/"
            >
              <img
                src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196631/instagram_przczs.png"
                alt="social"
              />
            </a>
            <a target="blank" href="https://www.facebook.com/dasmeshgroup">
              <img
                src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196631/facebook_ihbvi6.png"
                alt="social"
              />
            </a>
            <a target="blank" href="https://www.youtube.com/dasmeshgroup">
              <img
                src="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196691/youtube_ylqcgl.png"
                alt="social"
              />
            </a>
          </div>
        </div>
      </div>
      <hr />
      <div className="row" id="footer-tagline">
        <div className="col-lg-6 col-sm-12" id="footer-tagline-left">
          <p>
            ©{new Date().getFullYear()} <b>Dasmesh Group</b>. All rights reserved.
          </p>
        </div>
        <div className="col-lg-6 col-sm-12" id="footer-tagline-right">
          <Link to="https://www.pitamaas.com">
            <span>
              Designed & Developed by <b>Pitamaas</b>
            </span>
          </Link>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
